import React from 'react';
import { transformText } from './../utils/ColourMap';

function ColouredText(props) {
    let covertedtext = transformText(props.ColouredText);
    let clickText = props.onClick;
    let classNameToUse = "eomEditor my-2 p-2 eom-box";
    let rowsToShow = 3;
    if (props.rows !== undefined) {
        rowsToShow = props.rows;
    }
    if (props.overrideClassName !== undefined)
        classNameToUse = props.overrideClassName;

    let backgroundColor = props.overrideBackground;

    const style = { backgroundColor: backgroundColor };

    return (
        <div className={classNameToUse} rows={rowsToShow} dangerouslySetInnerHTML={{ __html: covertedtext }} onClick={clickText} style={style}/>
    );
}

export default ColouredText;